import { puedeUsarFlujos } from '../../lib/planCapabilities';

/**
 * Flag de la feature "Flujos" (canvas de nodos) — ADR-2026-09-04-canvas-flujos-enfoque.
 *
 * Mismo patrón que `FACTURACION_ENABLED` (`lib/checkoutPlans.ts`): mientras estuvo en
 * `false` la veían sólo las cuentas `dev_tester`. Desde
 * ADR-2026-09-14-flujos-es-de-pro-y-ultra está prendida para los clientes, con piso de plan
 * Pro/Ultra: la ruta hace su propio gate (rebota a `/subscription`) y la sidebar le pone
 * candado por `getModePlanLock('flujos')`. El ítem de la sidebar lleva `devOnly` sólo
 * mientras el flag esté en `false` — queda como kill-switch.
 */
export const FLUJOS_ENABLED = true;

/**
 * ¿Esta cuenta puede entrar a las pantallas de Flujos? Se llama con la cuenta YA cargada
 * de la base (`fetchCuentaFlujos`), o sea con plan y `dev_tester` autoritativos: acá no
 * hay "todavía no sé", y un plan que no llegó cuenta como que no alcanza.
 *
 * `dev_tester` pasa siempre, con el flag apagado o con un plan que no llega: es el mismo
 * trato que el Agente y los modos internos les dan a las cuentas del equipo.
 */
export function flujosVisible(cuenta: {
  devTester: boolean | null | undefined;
  plan: string | null | undefined;
}): boolean {
  if (cuenta.devTester === true) return true;
  return FLUJOS_ENABLED && puedeUsarFlujos(cuenta.plan);
}
